/**
 * Messages FR des tutorials
 */

module.exports = {

    currentStep: 'Step { currentStep } / { totalStep }',
    nextStepAltLabel: 'Proceed to the next step.',

    taskPlanning: {
        addNetwork: {
            title: 'Add your social networks',
            description: 'Use the "+" button to connect your social networks to publish.',
            nextStepLabel: 'Got it!'
        },
        addLateralMenuTask: {
            title: 'Add a post',
            description: 'Add a post via a prompt, a url, an image.',
            nextStepLabel: 'Got it!'
        },
        generatePlanning: {
            title: 'Generate your posts',
            description: 'Click the button to generate your new posts.',
            nextStepLabel: 'Got it!'
        },
        /*searching: {
            title: 'Perform a search',
            description: 'Search for a post in the list of publications.',
            nextStepLabel: 'Got it!'
        },
        filterTasks: {
            title: 'Sort by filters and status',
            description: 'Apply filters or status to sort your posts in the list.',
            nextStepLabel: 'Got it!'
        },*/
        taskList: {
            title: 'List of posts',
            description: 'Find here the list of posts of the month in chronological order.',
            nextStepLabel: 'Got it!'
        },
        /*regenerateTask: {
            title: 'List of posts',
            description: 'Regenerate a post by modifying the subject and AI parameters.',
            nextStepLabel: 'Got it!'
        },
        publicationDateTask: {
            title: 'List of posts',
            description: 'Find out the date and time recommended by Tookano.',
            nextStepLabel: 'Got it!'
        },*/
        /***/
        previewVisual: {
            title: 'Your visual',
            description: 'Display a larger image for a more detailed view.',
            nextStepLabel: 'Got it!'
        },
        editVisual: {
            title: 'Graphics editor',
            description: 'Click to edit the image and texts of your visual in advanced editing.',
            nextStepLabel: 'Got it!'
        },
        selectVisualCharter: {
            title: 'Graphic model',
            description: 'Select the graphic template of your choice or create your own.',
            nextStepLabel: 'Got it!'
        },
        selectVisual: {
            title: 'Background image',
            description: 'Select the background image that suits you best. Open the graphics editor to get new ones.',
            nextStepLabel: 'Got it!'
        },
        validVisual: {
            title: 'Your visual',
            description: 'Validate the visual of your post',
            nextStepLabel: 'Got it!'
        },
        regenerateVisual: {
            title: 'Your visual',
            description: 'Generate new visuals for your post.',
            nextStepLabel: 'Got it!'
        },
        changeHook: {
            title: 'Your tagline',
            description: 'Modify the proposed tagline by entering text.',
            nextStepLabel: 'Got it!'
        },
        regenerateHook: {
            title: 'Your tagline',
            description: 'Regenerate a new tagline by modifying the topic and AI parameters.',
            nextStepLabel: 'Got it!'
        },
        uploadMedia: {
            title: 'Upload your visual',
            description: 'Add your own visuals to your post.',
            nextStepLabel: 'Got it!'
        },
        /***/
        editTaskTitle: {
            title: 'Name of the post',
            description: 'Give your post a title for easy access.',
            nextStepLabel: 'Got it!'
        },
        editTaskPublicationDate: {
            title: 'Post date and time',
            description: 'Change the date and time of the post.',
            nextStepLabel: 'Got it!'
        },
        publicationPreview: {
            title: 'Preview',
            description: 'See how your post will appear on your social networks.',
            nextStepLabel: 'Got it!'
        },
        removeTask: {
            title: 'Remove the post',
            description: 'Delete the entire post.',
            nextStepLabel: 'Got it!'
        },
        regenerateTaskFromTaskDetails: {
            title: 'Regenerate the post',
            description: 'Check out the entire post (visual and tagline).',
            nextStepLabel: 'Got it!'
        },
        validTaskFromTaskDetails: {
            title: 'Validate the post',
            description: 'Schedule the post for distribution on selected social networks at the dates and times indicated.',
            nextStepLabel: 'Got it!'
        },
        /***/
        changeDisplayMode: {
            title: 'Display mode',
            description: 'Change your schedule display mode: list view or calendar view.',
            nextStepLabel: 'Got it!'
        },
        addTask: {
            title: 'Ajoutez une publication',
            description: 'Add your own publication or order a customized one from our CMs (using your credits).',
            nextStepLabel: 'Got it!'
        },
        iaSettings: {
            title: 'Set AI parameters',
            description: 'Modify the generic parameters taken into account by the AI: frequency, target, tone, emojis...',
            nextStepLabel: 'View my schedule'
        }
    }
};
